import { CheckList } from './CheckList';
import { ListDocument, QMASLazyDocument, Status } from 'app/modules/ui';
import { PRESETS_INSPECTION_RESULT } from 'app/modules/inspection/constants';

export const DESCRIPTION_CHECK_LIST_ITEM = [
  {
    label: 'Check Criteria',
    dataIndex: 'checkCriteria',
    span: 3,
    render: (value: string) => value || null
  },
  {
    label: 'Result',
    dataIndex: 'result',
    span: 3,
    render: (value: string) => {
      if (value) {
        const [text, color] = PRESETS_INSPECTION_RESULT.get(value) || [];
        return <Status type="text" value={text} color={color as string} />;
      }
    }
  },
  {
    label: 'Section Remarks',
    dataIndex: 'remark',
    span: 3,
    render: (value: string) => {
      return value || 'N/A';
    }
  },
  {
    label: 'Reference Media',
    dataIndex: 'referenceMedia',
    span: 3,
    className: 'reference-media',
    render: (value: any) => {
      if (Array.isArray(value)) {
        return (
          <div style={{ display: 'flex', gap: '10px' }}>
            {value.map((item) => {
              return (
                <QMASLazyDocument
                  key={item}
                  alt="attachments"
                  documentId={item}
                />
              );
            })}
          </div>
        );
      }
      return null;
    }
  },
  {
    label: 'Reference File',
    dataIndex: 'referenceFile',
    span: 3,
    className: 'reference-media',
    render: (value: any) => {
      if (Array.isArray(value)) {
        return <ListDocument dataSource={value} />;
      }
      return null;
    }
  }
];

export const DESCRIPTION_DEF = [
  {
    label: 'On-site Checking Progress',
    dataIndex: 'progress',
    span: 3,
    render: (value: string) => {
      return value || 'N/A';
    }
  },
  {
    label: null,
    dataIndex: 'checkList',
    render: (value) => {
      return (
        <CheckList value={value} descriptionDef={DESCRIPTION_CHECK_LIST_ITEM} />
      );
    }
  }
];
